import StorageProvider from './storage_provider'

export default class SessionStorageProviderSingleton {
  static instance = null

  constructor() {
    throw new Error('This class is Singleton')
  }

  /**
   * singleton method
   * @static
   * @return StorageProvider
   */
  static getInstance() {
    if (SessionStorageProviderSingleton.instance === null) {
      SessionStorageProviderSingleton.instance = new StorageProvider(window.sessionStorage)
    }
    return SessionStorageProviderSingleton.instance
  }
}
